import {
    UkgDateFormat, BidProfileStatus, BidProfileStatusNames, EmployeeBiddingStatus
} from '@enums/index';
import DateFormatService from '../../../services/DateFormatService';
import { getEmployeeSubmissionStatusLabel } from '../../../Enums/Helpers/LabellingHelper';

/**
 * @param {BidProfileStatus} status 
 * @param {BidProfileManagement.EmployeeSubmissionStatus} bidSelectionStatus 
 */
export function getStatusName(status, bidSelectionStatus) {
    if (status === BidProfileStatus.Canceled) {
        return BidProfileStatusNames[BidProfileStatus.Canceled];
    }
    return getEmployeeSubmissionStatusLabel(bidSelectionStatus ?? EmployeeBiddingStatus.Unsubmitted);
}

/**
 * @param {string|Date|null} date 
 */
export const getStatusDateLabel = (date) => (
    DateFormatService.formatDateOrEmpty(
        date,
        UkgDateFormat.LongDateTime,
    )
);

/**
 * @param {EmployeeBidProfile.IEmployeeArchiveBidProfile} bid
 * @param {string} search
 */
export const searchBid = (bid, search) => `${bid.name}
        |${bid.archivedStatus}
        |${bid.statusDate}
        `.toLocaleLowerCase().includes(search.toLocaleLowerCase());

/**
 * @param {EmployeeBidProfile.IEmployeeBidProfile} bid
 * @returns {EmployeeBidProfile.IEmployeeArchiveBidProfile}
 */
export const mapBidProfilesToTable = (bid) => ({
    bidProfileId: bid.profileId,
    name: bid.name,
    archivedStatus: getStatusName(bid.status, bid.employeeSubmissionStatus),
    statusDate: bid.signOffDate || bid.cancelationDate,
});
